import { ID } from 'shared/types/id';

import { getLoggableError } from './get-loggable-error';
import { getRollbar } from './rollbar';

export enum FirestoreWriteOp {
  CreatePushToken = 'create-push-token',
  DeletePushToken = 'delete-push-token',
}

type LogFirestoreWriteErrorArguments = {
  op: FirestoreWriteOp;
  error: unknown;
  docPath?: string;
  uid?: ID;
  extra?: Record<string, unknown>;
};

export const logFirestoreWriteError = ({
  op,
  error,
  docPath,
  uid,
  extra,
}: LogFirestoreWriteErrorArguments) => {
  getRollbar().error(`Firestore write failed: ${op}`, error as Error, {
    op,
    docPath,
    uid,
    ...getLoggableError(error),
    ...extra,
  });
};
